/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchRuleStateResponse
 */
export interface SearchRuleStateResponse {
    /**
     * 
     * @type {string}
     * @memberof SearchRuleStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchRuleStateResponse
     */
    errorMessage?: string | null;
}

export function SearchRuleStateResponseFromJSON(json: any): SearchRuleStateResponse {
    return SearchRuleStateResponseFromJSONTyped(json, false);
}

export function SearchRuleStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function SearchRuleStateResponseToJSON(value?: SearchRuleStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


